// reach_ui/src/actions/data.js
// TODO: MAKE THESE ALL TAKE THE SAME TYPES IN AN OBJECT
// MAYBE SINGLE FUNCTION THAT TAKES PARAMS FOR WHICH CRUD TYPE IT IS

import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import AJV from 'ajv'
import entityTypeEndpointMap from 'utils/entityTypeEndpointMap'
import { openSnackbar } from 'actions/view'

export const list =
  (
    entityType,
    idString = null,
    url,
    extraProperties,
    returnItem,
    replaceList,
    params,
    filter,
  ) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.Data.LIST_REQUEST,
        entityType,
        idString,
        url,
      })

      const URL =
        url || `${API_URL}/${entityTypeEndpointMap(entityType)}${params || ''}`

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(URL, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res => {
              const cursor = res?.headers?.get?.('x-vast-list-cursor')

              return res?.json?.().then?.(data => {
                const newData = { response: data }

                if (cursor) {
                  newData.cursor = cursor
                }

                if (!res.ok) {
                  newData.notOk = true
                }

                return newData
              })
            })
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.LIST_FAILURE,
                  payload: payload.response,
                  entityType,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Data.LIST_SUCCESS,
                payload: payload.response,
                entityType,
                idString,
                extraProperties,
                returnItem,
                replaceList,
                cursor: payload.cursor,
                filter,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Data.LIST_FAILURE,
                payload: error,
                entityType,
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err && err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const create =
  ({
    entity,
    entityType,
    path = null,
    noReturnValue = false,
    hasSchema = true,
    url = null,
    snackbarMessage = null,
  }) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({ type: ActionType.Data.CREATE_REQUEST, entity, entityType })

      const { schemas } = getState()
      const schema = schemas?.[entityType]?.POST

      const postHelper = schema => {
        if (hasSchema) {
          const ajv = new AJV({ verbose: true, allErrors: true })
          const valid = ajv
            .addSchema(schema, 'postSchema')
            .validate('postSchema', entity)

          if (!valid) {
            dispatch({
              type: ActionType.Data.VALIDATION_FAILURE,
              payload: valid,
              errors: ajv.errors,
              errorsText: ajv.errorsText(),
              entity,
              entityType,
              schema,
            })
            return valid
          }
        }

        return Auth.currentSession()
          .then(session => {
            dispatch({ type: ActionType.Data.VALIDATION_SUCCESS, schema })
            const headerValue = `Bearer ${session.idToken.jwtToken}`

            const obj = {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'POST', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            }

            if (entity) {
              obj.body = JSON.stringify(entity)
            }

            return fetch(
              typeof url === 'string'
                ? url
                : `${API_URL}/${
                    typeof path === 'string'
                      ? path
                      : entityTypeEndpointMap(entityType)
                  }`,
              obj,
            )
              .then(res =>
                res.json().then(data => {
                  if (!res.ok) {
                    return { notOk: true, ...data }
                  }
                  return data
                }),
              )
              .then(
                payload => {
                  if (payload && payload.notOk) {
                    dispatch({
                      type: ActionType.Data.CREATE_FAILURE,
                      payload,
                      entityType,
                      notOk: true,
                    })
                    reject(payload)
                    return
                  }

                  dispatch({
                    type: ActionType.Data.CREATE_SUCCESS,
                    payload,
                    entityType,
                    noReturnValue,
                    snackbarMessage,
                  })
                  resolve(payload)
                },
                error => {
                  dispatch({
                    type: ActionType.Data.CREATE_FAILURE,
                    payload: error,
                    entityType,
                  })
                  reject(error)
                },
              )
          })
          .catch(err => {
            console.log(err)
            if (err.code === 'UserNotFoundException') {
              window.localStorage.clear()
              window.location.reload(true)
            }
          })
      }

      if (schema || !hasSchema) {
        return postHelper(schema)
      } else {
        return dispatch(getSchema(entityType, 'POST', path)).then(schema =>
          postHelper(schema),
        )
      }
    })

export const read =
  (
    entityID,
    entityType,
    endpoint,
    idString,
    returnType = 'object',
    id,
    params,
    url,
  ) =>
  dispatch =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.Data.READ_REQUEST,
        entityID,
        entityType,
        endpoint,
        idString,
        returnType,
        id,
        params,
        url,
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          const URL = url
            ? url
            : endpoint
            ? `${API_URL}/${endpoint}${entityID ? `/${entityID}` : ''}${
                params || ''
              }`
            : `${API_URL}/${entityTypeEndpointMap(entityType)}${
                entityID ? '/' + entityID : ''
              }${params || ''}`

          return fetch(URL, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res => {
              const cursor = res.headers.get('x-vast-list-cursor')

              return res.json().then(data => {
                const newData = data

                if (cursor) {
                  newData.cursor = cursor
                }

                if (!res.ok) {
                  newData.notOk = true
                }

                return newData
              })
            })
            .then(
              payload => {
                if (payload && payload.notOk) {
                  dispatch({
                    type: ActionType.Data.READ_FAILURE,
                    entityID,
                    payload,
                    entityType,
                    notOk: true,
                    returnType,
                  })
                  reject(payload)
                  return
                }

                dispatch({
                  type: ActionType.Data.READ_SUCCESS,
                  entityID,
                  payload,
                  entityType,
                  idString,
                  returnType,
                  id,
                })
                resolve(payload)
              },
              error => {
                dispatch({
                  type: ActionType.Data.READ_FAILURE,
                  entityID,
                  payload: error,
                  entityType,
                  idString,
                  returnType,
                })
                reject(error)
              },
            )
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const readBlob =
  (
    entityID,
    entityType,
    endpoint,
    idString,
    returnType = 'object',
    id,
    params,
  ) =>
  dispatch =>
    new Promise((resolve, reject) => {
      dispatch({
        type: 'Data.READ_BLOB_REQUEST',
        entityID,
        entityType,
        endpoint,
        idString,
        returnType,
        id,
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(
            endpoint
              ? `${API_URL}/${endpoint}${entityID ? `/${entityID}` : ''}${
                  params || ''
                }`
              : `${API_URL}/${entityTypeEndpointMap(entityType)}${
                  entityID ? '/' + entityID : ''
                }${params || ''}`,
            {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            },
          )
            .then(res => {
              // const cursor = res.headers.get('x-vast-list-cursor')

              return res.blob().then(data => {
                const newData = data

                // if (cursor) {
                // 	newData.cursor = cursor
                // }

                // if (!res.ok) {
                // 	newData.notOk = true
                // }

                return newData
              })
            })
            .then(
              payload => {
                const imageObjectURL = URL.createObjectURL(payload)
                console.log(imageObjectURL)

                const reader = new FileReader()
                reader.readAsDataURL(payload)
                reader.onloadend = () => {
                  const base64Data = reader.result
                  console.log('base64Data:')
                  console.log(base64Data)

                  dispatch({
                    type: 'Data.READ_BLOB_SUCCESS',
                    entityID,
                    payload: base64Data,
                    entityType,
                    idString,
                    returnType,
                    id,
                  })
                  resolve(base64Data)
                }

                // if (payload && payload.notOk) {
                // 	dispatch({
                // 		type: 'Data.READ_BLOB_FAILURE',
                // 		entityID,
                // 		payload,
                // 		entityType,
                // 		notOk: true,
                // 		returnType,
                // 	})
                // 	reject(payload)
                // 	return
                // }
              },
              error => {
                dispatch({
                  type: 'Data.READ_BLOB_FAILURE',
                  entityID,
                  payload: error,
                  entityType,
                  idString,
                  returnType,
                })
                reject(error)
              },
            )
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

// TODO: configure this to take an object
export const update =
  (
    entity = null,
    entityType,
    endpoint,
    path = '',
    idString,
    noSchema,
    snackbarMessage,
    url,
  ) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.Data.UPDATE_REQUEST,
        entity,
        entityType,
        endpoint,
        path,
        idString,
        url,
      })
      const { schemas } = getState()

      const schema = endpoint ? true : schemas[entityType]?.PUT

      const putHelper = schema => {
        if (schema) {
          const ajv = new AJV({ verbose: true, allErrors: true })
          const valid = entity
            ? ajv.addSchema(schema, 'putSchema').validate('putSchema', entity)
            : true

          if (!valid) {
            dispatch({
              type: ActionType.Data.VALIDATION_FAILURE,
              payload: valid,
              errors: ajv.errors,
              errorsText: ajv.errorsText(),
              entity,
              entityType,
              schema,
            })
            return valid
          }
        }

        return Auth.currentSession()
          .then(session => {
            dispatch({ type: ActionType.Data.VALIDATION_SUCCESS, schema })
            const headerValue = `Bearer ${session.idToken.jwtToken}`
            const dataWithoutBody = {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'PUT', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            }
            const data = entity
              ? { ...dataWithoutBody, body: JSON.stringify(entity) }
              : dataWithoutBody

            return fetch(
              url || `${API_URL}/${entityTypeEndpointMap(entityType)}${
                typeof endpoint === 'string'
                  ? `${endpoint}`
                  : entity && entity.id
                  ? `/${entity.id}`
                  : ''
              }`,
              data,
            )
              .then(res => {
                return res.json().then(data => {
                  if (!res.ok) {
                    return { notOk: true, ...data }
                  }
                  return data
                })
              })
              .then(
                payload => {
                  if (payload && payload.notOk) {
                    dispatch({
                      type: ActionType.Data.UPDATE_FAILURE,
                      payload,
                      entityType,
                      endpoint,
                      path,
                      idString,
                      notOk: true,
                      url,
                    })
                    reject(payload)
                    return
                  }

                  dispatch({
                    type: ActionType.Data.UPDATE_SUCCESS,
                    payload: entity ? payload : null,
                    entityType,
                    endpoint,
                    path,
                    idString,
                    snackbarMessage,
                    url,
                  })
                  resolve(payload)
                },
                error => {
                  dispatch({
                    type: ActionType.Data.UPDATE_FAILURE,
                    payload: error,
                    entityType,
                    endpoint,
                    path,
                    idString,
                    url,
                  })
                  reject(error)
                },
              )
          })
          .catch(err => {
            console.log(err)
            if (err.code === 'UserNotFoundException') {
              window.localStorage.clear()
              window.location.reload(true)
            }
          })
      }

      if (noSchema) {
        return putHelper(false)
      }

      if (schema) {
        return putHelper(schema)
      } else {
        return dispatch(getSchema(entityType, 'PUT', path)).then(schema =>
          putHelper(schema),
        )
      }
    })

export const deleteEntity =
  (id, entityType, url, snackbarMessage, thenFunc, entity) => dispatch =>
    new Promise((resolve, reject) => {
      dispatch({ type: ActionType.Data.DELETE_REQUEST })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(
            typeof url === 'string'
              ? url
              : `${API_URL}/${entityTypeEndpointMap(entityType)}/${id}`,
            {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            },
          )
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(
              payload => {
                if (payload && payload.notOk) {
                  dispatch({
                    type: ActionType.Data.DELETE_FAILURE,
                    payload,
                    entityType,
                    notOk: true,
                  })
                  reject(payload)
                  return
                }

                dispatch({
                  type: ActionType.Data.DELETE_SUCCESS,
                  id,
                  entityType,
                  snackbarMessage,
                  entity,
                })

                if (entityType === 'account/user') {
                  dispatch(
                    // thenFunc
                    openSnackbar({
                      type: 'success',
                      message: `User ${payload?.username} deleted.${
                        payload?.user_contact_count
                          ? ` ${payload.user_contact_count} contacts unassigned.`
                          : ''
                      }`,
                      detail: 'userDeleted',
                    }),
                  )
                }

                resolve(payload)
              },
              error => {
                dispatch({
                  type: ActionType.Data.DELETE_FAILURE,
                  payload: error,
                  entityType,
                })
                reject(error)
              },
            )
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const deleteSuccess =
  ({ id, entityType }) =>
  dispatch =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.Data.DELETE_SUCCESS,
        id,
        entityType,
        snackbarMessage: 'none',
      })
      return resolve()
    })

export const getSchema =
  (entityType, requestType, path = '') =>
  (dispatch, getState) => {
    dispatch({ type: ActionType.Schemas.REQUEST })

    const url = {
      POST: `${API_URL}/schema/${
        path ? (typeof path === 'string' ? path : path.value) : entityType
      }/POST/request/`,
      PUT: `${API_URL}/schema/${
        path
          ? typeof path === 'string'
            ? path
            : path.value
          : `${entityType}/${entityType}Id`
      }/PUT/request/`,
    }

    return new Promise((resolve, reject) => {
      return fetch(url[requestType], {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          dnt: 0,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(
          schema => {
            if (schema.notOk) {
              dispatch({
                type: ActionType.Schemas.FAILURE,
                payload: schema,
              })
              reject(schema)
              return
            }

            dispatch({
              type: ActionType.Schemas.SUCCESS,
              payload: { schema, requestType },
            })
            resolve(schema)
          },
          error => {
            dispatch({
              type: ActionType.Schemas.FAILURE,
              payload: error,
            })
            reject(error)
          },
        )
    })
  }
